"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _http = require("./http");

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_http).default;
  }
});
Object.defineProperty(exports, "get", {
  enumerable: true,
  get: function get() {
    return _http.get;
  }
});
Object.defineProperty(exports, "put", {
  enumerable: true,
  get: function get() {
    return _http.put;
  }
});
Object.defineProperty(exports, "patch", {
  enumerable: true,
  get: function get() {
    return _http.patch;
  }
});
Object.defineProperty(exports, "post", {
  enumerable: true,
  get: function get() {
    return _http.post;
  }
});
Object.defineProperty(exports, "delete", {
  enumerable: true,
  get: function get() {
    return _http._delete;
  }
});
Object.defineProperty(exports, "registerStatusCodes", {
  enumerable: true,
  get: function get() {
    return _http.registerStatusCodes;
  }
});
Object.defineProperty(exports, "clearStatusCodes", {
  enumerable: true,
  get: function get() {
    return _http.clearStatusCodes;
  }
});
Object.defineProperty(exports, "registerRoutes", {
  enumerable: true,
  get: function get() {
    return _http.registerRoutes;
  }
});
Object.defineProperty(exports, "clearRoutes", {
  enumerable: true,
  get: function get() {
    return _http.clearRoutes;
  }
});
Object.defineProperty(exports, "buildQueryString", {
  enumerable: true,
  get: function get() {
    return _http.buildQueryString;
  }
});
Object.defineProperty(exports, "formatUrl", {
  enumerable: true,
  get: function get() {
    return _http.formatUrl;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}